import { toast } from '@mx/vix';
import { normalizeError } from '@mx/pay-common';
import { showResultPage } from './showResultPage';
import {
  AccessSource,
  bridge,
  CallbackPayResultSource,
  env,
  metricPoints,
  monitor,
  queryOrder,
  QueryOrderStatus,
  PayFailAction,
} from '@/common';
import { showErrorModal } from './errorModal';
import { deferCashierPaySuccess, deferCashierUnknownPayStatus, downgradeStandardCashier } from './callbackNativeRouter';
import { storeInstance } from '@/store';
// 支付结果页数据
let promotion = {};
// >= 9.8.0 通过自建桥展示结果页面并回调业务方，否则沿用原流程
// const useNewCashierCallback = env.specialNeoInitParams.promotion_degrade_switch === 'open' && compareVersion(env.commonParams.sdk_version, '9.8.0') >= 0;
/**
 * 收银台快照桥，仅应用于Android
 * https://km.sankuai.com/page/1300713968
 */
function snapShotAndPaySuccess() {
  bridge
    .notifyNative('pay.cashierSnapShot', {})
    .then(() => {
      monitor.captureInfo('[bridge]pay.cashierSnapShot 调用成功', { promotion });
      deferCashierPaySuccess(promotion);
    })
    .catch((e: any) => {
      deferCashierPaySuccess(promotion);
      monitor.captureJSErrorMessage('[bridge]pay.cashierSnapShot 调用失败无法响应快照', { error: normalizeError(e) });
    });
}

/**
 * 回调业务方
 * >= 9.8.0 Native展示支付后弹窗，直接回调业务方。
 * @returns
 */
function callbackPayResultNew(source: string) {
  monitor.captureResourceInfoMessage(`[info]callbackPayResultNew 执行来源: ${source}`, { promotion });
  if (env.isIOS) {
    deferCashierPaySuccess(promotion);
  } else {
    snapShotAndPaySuccess();
  }
}

/**
 * 回调业务方
 * sdk < 9.8.0 关闭支付后弹窗后，根据订单状态判断，是回调业务方支付成功，还是降级标准收银台去支付
 * @returns
 */
function callbackPayResultOld(source: string) {
  monitor.captureResourceInfoMessage(`[info]callbackPayResultOld 执行来源: ${source}`, { promotion });
  deferCashierPaySuccess();
}

/**
 * 接入方为Hybrid标准收银台，由收银台展示结果页
 * 支付SDK 9.8.0 及以上，由Native展示支付结果页（解决收银台重入无法支付问题，文档：https://km.sankuai.com/page/1110737342）
 * 支付SDK 9.8.0 及以下，维持原状
 */
function checkVersionAndSwitchStatusCallback(source: string) {
  // https://km.sankuai.com/page/1110737342
  // 若接入方是web-cashier，则只setResult promotion，由web-cashier打开结果页
  if (env.useNewCashierCallback || env.access_source === AccessSource.WebCashier) {
    callbackPayResultNew(source);
  } else {
    showResultPage(promotion, callbackPayResultOld);
  }
}
export function queryOrderStatusFailCallback(source: string) {
  monitor.captureResourceInfoMessage(`[info]QueryOrderStatusFail 执行来源: ${source}`, { promotion });
  // 存结果页数据
  const store = storeInstance();
  // 展示结果页
  store.commit({ type: 'result/setShowResult', showResult: true });
  store.commit({ type: 'result/setResultData', resultData: promotion });
}
export function payFailButtonClick() {
  if (env.payFailAction === PayFailAction.guideFinish) {
    deferCashierUnknownPayStatus();
  } else {
    downgradeStandardCashier();
  }
}
export function pollingQueryOrder(count: number, interval: number) {
  // 轮询次数为0接口均失败，且 promotion 没有值，则展示兜底弹窗，引导用户去支付
  if (count <= 0 && Object.keys(promotion).length <= 0) {
    toast.hide();
    showErrorModal({ title: '先用后付暂未获取支付结果', content: '为不影响您的使用请先完成支付' });
    return;
  }
  // 轮询次数为0且状态仍为 'new'或'fail'，直接打开签约结果页
  if (count <= 0) {
    toast.hide();
    // 支付失败的时候走此流程
    queryOrderStatusFailCallback(CallbackPayResultSource.inPayFail);
    return;
  }

  setTimeout(() => {
    queryOrder({
      ...env.inpayBasicBusinessParams,
      isauto: 1, // 自动
      query_type: 2, // 获取先用后付支付结果页
    })
      .then((res) => {
        promotion = res.pay_result_page || promotion; // 默认值是 {},如果上一次有返回值本次没有返回值则用上一次的返回值
        env.setQueryOrderTradeStatus(res.trade_status);
        monitor.reportMetric(metricPoints.tradeStatus, { tradeStatus: res.trade_status });
        switch (res.trade_status) {
          case QueryOrderStatus.outstanding:
          case QueryOrderStatus.fail:
            pollingQueryOrder(count - 1, interval);
            break;
          case QueryOrderStatus.success:
            toast.hide();
            checkVersionAndSwitchStatusCallback(CallbackPayResultSource.inPaySuccess);
            break;
          default:
            throw new Error('trade_status 下发异常');
        }
      })
      .catch((error) => {
        monitor.captureAjaxErrorMessage('[api]queryorder接口请求失败', { error: normalizeError(error) });
        if (count > 0) {
          pollingQueryOrder(count - 1, interval);
        }
      });
  }, interval);
}
